import { render, staticRenderFns } from "./TournamentEditTeams.vue?vue&type=template&id=6887899e&scoped=true"
import script from "./TournamentEditTeams.vue?vue&type=script&lang=js"
export * from "./TournamentEditTeams.vue?vue&type=script&lang=js"
import style0 from "./TournamentEditTeams.vue?vue&type=style&index=0&id=6887899e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887899e",
  null
  
)

export default component.exports